module.exports = __webpack_public_path__ + "img/mandaya.4f9e2be5.jpeg";